import {isString} from 'lodash';
import React, {useEffect, useMemo, useState} from 'react';

import {getClientCity} from 'ultra/configs/general';
import {ignoreTextFieldKeys, getRegexpDescription} from "ultra/helpers/utils";

import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import {useToasterStore} from '../../../Stores/toster';
import {useFormStore} from '../../../Stores/form';

import {getTags} from '../../../Helpers/content'

export default function Tags(props) {
    const {content, disabled, field, isEditMode, error, onChange, onBlur} = props

    const {formVisibleErrors} = useFormStore();

    const showErrorText = formVisibleErrors[field.id];

    const multiple = !Boolean(field?.options?.single);
    const defaultValue = multiple ? [] : '';

    const {showError} = useToasterStore();

    const [value, setValue] = useState(defaultValue)
    const [list, setList] = useState([])

    const [regexpHighlight, setRegexpHighlight] = useState(false)

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    useEffect(() => {
        const city = content._city || getClientCity(window)

        if (content._type) {
            getTags(city, content._type, field.id)
                .promise
                .then(res => {
                    setList(res.tags || [])
                })
        }
    }, [content._type])

    useEffect(() => {
        let newValue
        if (content[field.id]) {
            newValue = content[field.id] || defaultValue
        } else {
            newValue = defaultValue
        }
        // if (!isEqual(value, newValue)) 
        setValue(newValue);
    }, [content[field.id]])

    const formatedRegexp = useMemo(() => {
        if (!field?.options?.regexp) return "";

        return "Доступні для вводу символи: " + getRegexpDescription(field.options.regexp);
    }, [field?.options?.regexp])

    const onBlurHandler = (e) => {
        setRegexpHighlight(false);
        onBlur(e);
    }

    const onKeyDownHandler = (e) => {
        if (!field?.options?.regexp) return false;
        const regex = new RegExp(field.options.regexp);

        if (((e.ctrlKey || e.metaKey) && e.key === 'v') || e.key === 'Enter') {
            if (!ignoreTextFieldKeys(e) && !regex.test(e?.target?.value)) {
                setRegexpHighlight(true);
            }
            else {
                setRegexpHighlight(false);
            }

            return false;
        }

        if (!ignoreTextFieldKeys(e) && !regex.test(e.key)) {
            e.preventDefault();
            setRegexpHighlight(true);
        }
        else {
            setRegexpHighlight(false);
        }
    }

    const onPasteHandler = (e) => {
        if (field?.options?.regexp) {
            const regex = new RegExp(field.options.regexp);
            const pastedData = (e.clipboardData || window.clipboardData).getData('text');
            if (!regex.test(pastedData)) {
                setRegexpHighlight(true);
                e.preventDefault();
            }
        }
    }

    return (<>
        <Autocomplete
            multiple={multiple}
            freeSolo

            fullWidth
            
            options={list.map((option) => option)}
            
            autoSelect={true}

            value={value}

            getOptionLabel={(option) => {
                if (isString(option)) {
                    return option
                }
                else {
                    return ''
                }
            }}

            onChange={(e, value) => {
                if (multiple) {
                    if (field?.options?.max && value.length > field.options.max) {
                        showError({snackbarMessage: `Для поля "${field.placeholder}" ви можете обрати не більше ${field.options.max} значень`})
                        return;
                    }

                    onChange({target: {value: value.map(i => i.trim())}})
                }
                else {
                    onChange({target: {value}})
                }
            }}

            renderTags={(value, get) => {
                    if (multiple) {
                        return value.map((option, index) => {
                            const data = get({index});
                            // ...data
                            return <Chip variant="outlined" label={option} className={data.className} key={`tag_${field.id}_${data.key}`} />
                        })
                    }
                    else {
                        return <span>{value}</span>;
                    }
                }
            }

            disabled={isDisabled}

            renderInput={(params) => (
                <TextField
                    {...params}

                    onKeyDown={onKeyDownHandler}
                    onBlur={onBlurHandler}
                    onPaste={onPasteHandler}
                    variant='outlined'
                    label={field.placeholder}
                    required={field.required}

                    placeholder='Введіть значення та натисніть Enter'

                    error={Boolean(showErrorText)}
                    helperText={showErrorText && error}
                />
                
            )}
        />

        {field?.details && <div className="fieldNotes">
            <p>{field.details}</p>
        </div>}

        {regexpHighlight && field?.options?.regexp && <div className={regexpHighlight ? "fieldNotes fieldNotesRegexpError" : "fieldNotes"}>
            <p>{formatedRegexp}</p>
        </div>}
    </>)
}
